export default __webpack_public_path__ + "static/media/obsfile.760cdf01.pdf";